import { LogglyTracker } from 'loggly-jslogger';

import AppHelper from '../core-components/AppHelper';

const logger = new LogglyTracker();

logger.push({
  logglyKey: '6d2cfdee-91e3-46aa-81c5-4ba4a567ec43',
  tag: `springverify-client-${AppHelper.getEnv()}`,
  sendConsoleErrors: true
});

export default logger;
